import { useField } from "formik";
import { Input, Textarea } from "neetoui/formik";

import Checkbox from "./Checkbox";
import DragHandle from "./DragHandle";
import OptionActions from "./OptionActions";

const InputOption = ({
  shouldFocus,
  hideDeleteOption = false,
  hideCloneOption = false,
  innerRef,
  draggableProps,
  dragHandleProps,
  onKeyDown,
  onDelete,
  onClone,
  onChange,
  optionIndex,
  disabled,
  isTextArea,
  id,
  isDraggable,
  name,
  placeholder,
  onBlur,
  arrayHelpers,
  isCheckboxEnabled = false,
}) => {
  const Component = isTextArea ? Textarea : Input;
  const [field] = useField(name);

  return (
    <div
      ref={innerRef}
      {...{ ...draggableProps, ...dragHandleProps }}
      data-testid="form-block-options"
    >
      <div className="nf-input-options group relative mb-2 flex items-start gap-1">
        {isDraggable && (
          <DragHandle
            {...dragHandleProps}
            data-testid={`drag-handle-${optionIndex}`}
          />
        )}
        {isCheckboxEnabled && <Checkbox {...{ name, optionIndex }} />}
        <div className="flex w-full items-start gap-2">
          <Component
            {...{ disabled, name, onKeyDown, placeholder }}
            autoFocus={shouldFocus}
            className="flex-1"
            data-testid={`${
              isTextArea ? "option-textarea" : "option-input"
            }-${optionIndex}`}
            suffix={
              <OptionActions
                {...{
                  arrayHelpers,
                  disabled,
                  hideCloneOption,
                  hideDeleteOption,
                  id,
                  onClone,
                  onDelete,
                  optionIndex,
                }}
              />
            }
            onChange={({ target }) => onChange({ id, value: target.value })}
            onFocus={({ target }) => target.select()}
            onBlur={(event, ...args) => {
              onChange({ id, value: event.target.value, isOnBlur: true });
              onBlur?.(id, event.target.value);
              field.onBlur(event, ...args);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default InputOption;
